if (!customElements.get("pickup-availability")) {
  customElements.define("pickup-availability", class extends HTMLElement {
    constructor() {
      super();
      this.errorHtml = this.querySelector("template")?.content.firstElementChild.cloneNode(true);
      this.previews = new Map();
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      const preview = this.querySelector("pickup-availability-preview");
      if (preview) this.previews.set(String(this.dataset.variantId), preview.outerHTML);
      if (this.dataset.variantId) this.fetchAvailability(this.dataset.variantId);
    }
    async fetchAvailability(variantId) {
      const id = String(variantId);
      const changed = this.dataset.variantId !== id;
      this.dataset.variantId = id;
      const request = this.request = (this.request || 0) + 1;
      if (changed) {
        document.querySelector("pickup-availability-drawer")?.remove();
        this.innerHTML = this.previews.get(id) || "";
      }
      try {
        let rootUrl = this.dataset.rootUrl || "/";
        if (!rootUrl.endsWith("/")) rootUrl += "/";
        const response = await fetch(`${rootUrl}variants/${id}/?section_id=pickup-availability`);
        if (!response.ok) throw new Error("Pickup availability request failed");
        const text = await response.text();
        if (request !== this.request) return;
        const section = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
        if (!section) throw new Error("Pickup availability section missing");
        this.renderPreview(section, id);
      } catch (error) {
        if (request === this.request) this.renderError(id);
      }
    }
    onClickRefreshList() { this.fetchAvailability(this.dataset.variantId); }
    renderError(id) {
      const preview = this.previews.get(id);
      if (preview) {
        this.innerHTML = preview;
        this.querySelector("button")?.remove();
        this.setAttribute("available", "");
        return;
      }
      this.innerHTML = "";
      if (!this.errorHtml) return;
      this.appendChild(this.errorHtml.cloneNode(true));
      this.querySelector("button")?.addEventListener("click", this.onClickRefreshList);
    }
    renderPreview(section, id) {
      const preview = section.querySelector("pickup-availability-preview");
      const drawer = section.querySelector("pickup-availability-drawer");
      document.querySelector("pickup-availability-drawer")?.remove();
      if (!preview) {
        this.innerHTML = "";
        this.previews.delete(id);
        this.removeAttribute("available");
        return;
      }
      this.previews.set(id, preview.outerHTML);
      this.innerHTML = preview.outerHTML;
      this.setAttribute("available", "");
      if (drawer) {
        document.body.appendChild(drawer);
        this.querySelector("button")?.addEventListener("click", event => drawer.show(event.target));
      }
    }
  });
}
customElements.get("pickup-availability-drawer")||customElements.define("pickup-availability-drawer",class extends HTMLElement{constructor(){super(),this.onBodyClick=this.handleBodyClick.bind(this),this.querySelector("button").addEventListener("click",()=>{this.hide()}),this.addEventListener("keyup",()=>{"ESCAPE"===event.code.toUpperCase()&&this.hide()})}handleBodyClick(evt){const target=evt.target;target==this||target.closest("pickup-availability-drawer")||"ShowPickupAvailabilityDrawer"==target.id||this.hide()}hide(){this.removeAttribute("open"),document.body.removeEventListener("click",this.onBodyClick),document.body.classList.remove("added__overlay"),removeTrapFocus(this.focusElement)}show(focusElement){this.focusElement=focusElement,this.setAttribute("open",""),document.body.addEventListener("click",this.onBodyClick),document.body.classList.add("added__overlay"),trapFocus(this)}});